(() => {
  const init = root => {
    const wrappers = root.matches?.('[data-size-guide-video]') ? [root] : root.querySelectorAll?.('[data-size-guide-video]') || [];
    wrappers.forEach(wrapper => {
      if (wrapper.dataset.videoReady === 'true') return;
      wrapper.dataset.videoReady = 'true';
      const button = wrapper.querySelector('[data-size-video-toggle]');
      const visibleVideo = () => [...wrapper.querySelectorAll('video')].find(video => getComputedStyle(video).display !== 'none') || wrapper.querySelector('video');
      const sync = () => {
        const video = visibleVideo();
        const paused = !video || video.paused;
        button?.setAttribute('aria-pressed', String(paused));
        button?.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      };
      wrapper.querySelectorAll('video').forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
      });
      button?.addEventListener('click', () => {
        const video = visibleVideo();
        if (!video) return;
        if (video.paused) video.play().catch(() => {});
        else video.pause();
        sync();
      });
      sync();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
